export default {
  activity: {
    include_activity_owner: true,
    include_activity_owner_image: true,
  },
  artwork: {
    include_artwork_artwork_reviews: true,
    include_artwork_data_changes: true,
    include_artwork_pages: true,
  },
  artworkPage: {
    include_artwork_page_attachments: true,
    include_artwork_page_preview: true,
    include_artwork_page_warning_count: true,
  },
  artworkReview: {
    include_image_sizes: true,
  },
  attachment: {
    include_attachment_attachable: true,
    include_attachment_file: true,
  },
  campaign: {
    include_agent_user: true,
    include_campaign_agent_ids: true,
    include_campaign_agent_user_ids: true,
    include_campaign_agents: true,
    include_campaign_data_store_items: true,
    include_campaign_events: true,
    include_campaign_image: true,
    include_campaign_sensitive_data: true,
    include_campaign_status: true,
    include_campaign_team: true,
    include_image_sizes: true,
    include_team_member_user: true,
    include_team_members: true,
    include_user_image: true,
  },
  campaignContact: {
    include_campaign_contact_contact: true,
    include_contact_user: true,
  },
  campaignContribution: {
    include_campaign_contribution_receipt: true,
  },
  campaignQuote: {
    include_campaign_quote_links: true,
  },
  campaignQuoteItem: {
    include_campaign_quote_item_quote_dynamic_items: true,
    include_campaign_quote_item_quote_total: true,
  },
  conversation: {
    include_attachment_file: true,
    include_comment_attachments: true,
    include_comment_user: true,
    include_conversation_comments: true,
    include_conversation_last_comment: true,
    include_conversation_subject: true,
    include_conversation_subscribers: true,
    include_conversation_unread_count: true,
    include_image_sizes: true,
    include_subscriber_user: true,
    include_user_image: true,
  },
  dataStoreItem: {
    include_data_store_item_digital_template: true,
    include_data_store_item_editor: true,
  },
  image: {
    include_image_sizes: true,
  },
  order: {
    include_order_bundle: true,
    include_order_item_due_date: true,
    include_order_items: true,
    include_order_publication: true,
    include_order_publication_booking: true,
    include_order_publication_edition: true,
    include_order_publication_package: true,
  },
  orderItem: {
    include_order_item_artwork: true,
    include_order_item_deep_link: true,
    include_order_item_due_date: true,
    include_order_item_order_total: true,
    include_order_item_service: true,
    include_order_item_service_product: true,
    include_order_item_tasks: true,
  },
  orderItemTask: {
    include_task_attachment_image: true,
    include_task_attachments: true,
    include_task_instruction_image: true,
    include_task_type: true,
  },
  provider: {
    include_provider_alternate_logo: true,
    include_provider_blockout_dates: true,
    include_provider_disclaimers: true,
    include_provider_logo: true,
    include_provider_service_ids: true,
  },
  publication: {
    include_publication_logo: true,
  },
  publicationEdition: {
    include_publication_edition_deadlines: true,
  },
  trackingLink: {
    include_tracking_link_shortened_url: true,
    include_tracking_link_total_views: true,
  },
}
